export default "__VITE_ASSET__CyKQNcjd__"